"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxeptaResponseMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class AxeptaResponseMapper {
    toDomain(result) {
        const redirectUrl = lodash_1.default.get(result, "data.axeptaV2._links.redirect.href");
        return {
            redirectUrl,
        };
    }
}
exports.AxeptaResponseMapper = AxeptaResponseMapper;
